import { BaseDto } from '@/shared/dtos/base-dto';

export class cambioscontrasenasperdidas extends BaseDto {
    public email !: string;
    public id_usuario !: number;
    public token_generado !: string;
    public nueva_contra !: string;
    public url_production!:string;
 } 